"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A dictionary of codes for errors produced by this package.
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["PromiseTimeout"] = "SLACKMESSAGEUTIL_PROMISE_TIMEOUT";
    ErrorCode["SignatureVerificationFailure"] = "SLACKHTTPHANDLER_REQUEST_SIGNATURE_VERIFICATION_FAILURE";
    ErrorCode["RequestTimeFailure"] = "SLACKHTTPHANDLER_REQUEST_TIMELIMIT_FAILURE";
    ErrorCode["BodyParserNotPermitted"] = "SLACKADAPTER_BODY_PARSER_NOT_PERMITTED_FAILURE";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
/**
 * Factory for producing a {@link CodedError} from a generic error.
 */
function errorWithCode(error, code) {
    var codedError = error;
    codedError.code = code;
    return codedError;
}
exports.errorWithCode = errorWithCode;
//# sourceMappingURL=errors.js.map